import { Mail } from 'lucide-react';
import React from 'react';

function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const SUBSCRIPTION_CONTENT = {
    pending: {
        title: "We're Getting Things Ready",
        message: "We are working on your needs and will be available soon. Your account is being set up and will be activated shortly — thanks for your patience!",
    },
    inactive: {
        title: "Account Inactive",
        message: "Your company's subscription is currently inactive. Please contact your administrator or our support team to reactivate access.",
    },
    suspended: {
        title: "Account Suspended",
        message: "Your company's account has been temporarily suspended. Please get in touch with our support team to resolve this.",
    },
    cancelled: {
        title: "Subscription Cancelled",
        message: "Your company's subscription has been cancelled. Contact our team if you'd like to reactivate your account.",
    },
};

const DEFAULT_SUBSCRIPTION_CONTENT = {
    title: "Account Unavailable",
    message: "Your company's account isn't currently active. Please contact our support team for more information.",
};

const NotActiveAccount = ({ user, company, reason = "user" }) => {
    const isSubscriptionBlock = reason === "subscription";

    const subscriptionContent = isSubscriptionBlock
        ? (SUBSCRIPTION_CONTENT[company?.subscription_status] || DEFAULT_SUBSCRIPTION_CONTENT)
        : null;

    return (
        <div className="fixed w-full h-full top-0 left-0 bg-white flex items-center flex-col justify-center">
            <div className='mb-16'>
                <img className='w-60 h-auto' src={`${process.env.PUBLIC_URL}/assets/wide-logo-black.svg`} alt="" />
            </div>
            <div className='text-center items-center flex flex-col gap-y-4'>
                {isSubscriptionBlock ? (
                    <>
                        <p className='font-extrabold text-zinc-700 text-3xl'>{subscriptionContent.title}</p>
                        <p className='text-lg w-1/2'>
                            Hello{" "}
                            <span className='font-semibold text-green-700'>
                                {capitalizeFirstLetter(user?.full_name?.split(' ')[0] || user?.username)}
                            </span>!{" "}
                            {subscriptionContent.message}
                        </p>
                    </>
                ) : (
                    <>
                        <p className='font-extrabold text-zinc-700 text-3xl'>Oops! Can't Access Your Account</p>
                        <p className='text-lg w-1/2'>
                            Hello{" "}
                            <span className='font-semibold text-green-700'>
                                {capitalizeFirstLetter(user?.full_name?.split(' ')[0] || user?.username)}
                            </span>!{" "}
                            It looks like your account is <span className='font-semibold text-red-700'>{user.status.split("_").join(" ")}</span>. This usually means it's waiting to be activated by your administrator, or access has been temporarily restricted.
                        </p>
                    </>
                )}
                <p className='mt-12 text-lg w-1/2'>Think something's wrong? Get in touch with your company administrator or our support team—we're here to help!</p>
            </div>
            <div className='flex flex-row items-center justify-center align-middle gap-x-2 mt-4 text-green-700 font-semibold'>
                <Mail />
                <a href="mailto:info@notifyapp.com.au">info@notifyapp.com.au</a>
            </div>
        </div>
    );
};

export default NotActiveAccount;
